export default function shortNumber(n) {
	if (n >= 1000000000000) {
		n = (Math.round(100 * (n / 1000000000000))/100) + 'T';
	} else if (n >= 1000000000) {
		n = (Math.round(100 * (n / 1000000000))/100) + 'B';
	} else if (n >= 1000000) {
		n =(Math.round(100 * (n / 1000000))/100) + 'M';
	} else if (n >= 1000) {
		n = (Math.round(100 * (n / 1000))/100) + 'K';
	}

	return n;
}
